var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    ref: "paymentDetails",
    attrs: {
      id: "payment-details-modal",
      "modal-dialog-scrollable": false,
      "loaders-disabled": "",
      "header-class": "justify-content-center",
      "modal-dialog-size": "lg",
    },
    on: { hidden: _vm.$v.$reset },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _c("div", { staticClass: "header-logos" }, [
              _c("div", { staticClass: "logo-wrapper" }, [
                _c("img", {
                  staticClass: "w-100",
                  attrs: {
                    height: "auto",
                    src: require("@Shared/@Assets/img/mg.png"),
                    alt: _vm.$t("global.words.filogixLogo"),
                  },
                }),
              ]),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _c(
              "div",
              { staticClass: "modal-section payment-info-modal p-0 mt-5" },
              [
                _c("h4", { staticClass: "bold mt-2" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("payments.paymentDetails")) +
                      "\n      "
                  ),
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("p", { staticClass: "text-gray small" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t("payments.messages.reviewPaymentDetails")
                        ) +
                        "\n        "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "billing-info" },
                  [
                    _c("address-section", {
                      attrs: {
                        address: _vm.address,
                        "custom-expressions": _vm.addressCustomExpressions,
                        "validator-context": _vm.$v,
                        disabled: !_vm.isEditable,
                        "ignored-fields": [
                          "street-number",
                          "street-name",
                          "unit-number",
                          "street-direction",
                          "street-type",
                        ],
                      },
                      on: { change: _vm.handleAddressChange },
                    }),
                    _vm._v(" "),
                    _c(
                      "material-input",
                      {
                        attrs: {
                          value: _vm.cardExpiration,
                          label: _vm.$t("payments.cardInfo.expiration"),
                          "validator-context": _vm.$v,
                          disabled: !_vm.isEditable,
                          "label-for": "expirationDate-input",
                          "custom-expression": "cardExpiration",
                        },
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.cardExpiration,
                              expression: "cardExpiration",
                            },
                            {
                              name: "mask",
                              rawName: "v-mask",
                              value: {
                                mask: "99/9999",
                                greedy: false,
                                showMaskOnHover: false,
                              },
                              expression:
                                "{\n              mask: '99/9999',\n              greedy: false,\n              showMaskOnHover: false\n            }",
                            },
                          ],
                          staticClass: "material-input form-control form",
                          attrs: {
                            id: "expirationDate-input",
                            autocomplete: "off",
                          },
                          domProps: { value: _vm.cardExpiration },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.cardExpiration = $event.target.value
                            },
                          },
                        }),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _vm.isEditable
              ? _c("simple-button", {
                  attrs: {
                    disabled: _vm.$v.$invalid,
                    text: _vm.$t("global.actions.saveChanges"),
                    loading: _vm.loading,
                    "loading-succeeded": _vm.loadingSucceeded,
                  },
                  on: { click: _vm.editPaymentMethod },
                })
              : _vm._e(),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }